import React from "react";
import { Row, Col } from "react-bootstrap";
import { formatFloat } from "../../utils/format";
import useTrackBorrows from "../../hooks/useTrackBorrows";
import InteractionButton from "../InteractionButton";
import useClaims from "../../hooks/useClaims";
import useGenericCall from "../../hooks/useGenericCall";
import { useOnchainAccountLendingPool, useOnchainAccountBorrowable } from "../../hooks/useOnchain";
import { PoolTokenType } from "impermax-sdk";


export default function AccountLendingPoolFarming() {
  const availableReward = useGenericCall(
    useOnchainAccountLendingPool(), 
    onchainAccountLendingPool => onchainAccountLendingPool.getAvailableReward()
  );
  const bData = [PoolTokenType.BorrowableA, PoolTokenType.BorrowableB].map(
    borrowable => useGenericCall(useOnchainAccountBorrowable(borrowable), async onchainAccountBorrowable => ({
      symbol: await (await onchainAccountBorrowable.getPoolToken().getOffchainPoolToken()).getSymbol(),
      borrowedUSD: await onchainAccountBorrowable.getBorrowedUSD(),
      farmingShares: await onchainAccountBorrowable.getFarmingShares(),
    }))
  );

  const [trackBorrowsState, onTrackBorrows] = useTrackBorrows();
  const [claimsState, onClaims] = useClaims();

  if (!availableReward || !bData[0] || !bData[1]) return (null);

  const symbol = bData[0].symbol + "-" + bData[1].symbol;

  let claimString = "Claim ";
  for (let i = 0; i < availableReward.length; i++) {
    claimString += formatFloat(availableReward[i].amount, 4) + ' ' + availableReward[i].symbol;
    if (i < availableReward.length - 1) claimString += ' and ';
  }

  // if is farming, show to reward accumulated and show a button to claim it
  if (availableReward.length > 0 || (bData[0].borrowedUSD > 0.01 && bData[0].farmingShares > 0) || (bData[1].borrowedUSD > 0.01 && bData[1].farmingShares > 0))
    return (<>
      <Row className="account-lending-pool-claim">
        <Col md={12} className="col-claim-reward">
          <InteractionButton name={claimString} onCall={onClaims} state={claimsState} />  
        </Col>
      </Row>
    </>);

  // if doesn't have anything borrowed, tell the user to borrow or leverage
  if (bData[0].borrowedUSD + bData[1].borrowedUSD < 0.01) return  (<div className="account-lending-pool-farming">
    <div className="info">Leverage { symbol } or Borrow to start receiving the IMX reward</div>
  </div>);

  // if has borrowed, but it is not tracked, show a button to track the LP
  return  (<div className="account-lending-pool-farming">
    <div className="info">IMX reward on your borrowed position in { symbol } is not active</div>
    <div className="activate-imx-reward">
      <InteractionButton name="Activate IMX Reward" onCall={onTrackBorrows} state={trackBorrowsState} />  
    </div>
  </div>);
}